import React from 'react';

import isArchived from 'archive/isArchived';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import * as RunContextMenu from './RunContextMenu';
import {SidepanelRun} from './RunsSidepanelConstants';

interface RunSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  run: SidepanelRun;
  openResult: (item: ListableItem) => void;
  isChild: boolean;
}

export default function RunSidepanelItem(props: RunSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, run, isChild} = props;
  const date = fuzzydate(run.createdAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Created '}${date}`;
  const title = run.name;
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(run)}
      icon={<BenchlingIcon icon={ModelTypeConstants.ASSAY_RUN} />}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(run);
      }}
      parties={[{...run.creator, avatar_url: run.creator.avatar_url}]}
      subTitle={subtitle}
      title={{
        text: title,
        node: <div>{title}</div>,
      }}
      tooltipText=""
      onContextMenu={(e: React.SyntheticEvent) => {
        RunContextMenu.open(e.nativeEvent, run);
      }}
      isExpandable={false}
      isChild={isChild}
    />
  );
}
